import { PUZZLES_OBJECT } from "../../utils/constants";
import "./Puzzle.css";
import PuzzlePopup from "../PuzzlePopup/PuzzlePopup";
import React from "react";

function Puzzle() {
  const [popupStateOpen, setPopupStateOpen] = React.useState(false);
  const [activePuzzle, setActivePuzzle] = React.useState({});
  const handleClick = (e, puzzle) => {
    console.log(puzzle);
    setActivePuzzle(puzzle);
    setPopupStateOpen(true);
  };

  return (
    <>
      <h1>Puzzles</h1>
      <div className='puzzles__list'>
        {PUZZLES_OBJECT.map((puzzle, index) => (
          <img
            className='puzzle__card'
            key={index}
            src={process.env.PUBLIC_URL + puzzle.path}
            alt={puzzle.alt}
            onClick={(e) => handleClick(e, puzzle)}
          />
        ))}
      </div>
      <PuzzlePopup puzzle={activePuzzle} popupStateOpen={popupStateOpen} />
    </>
  );
}

export default Puzzle;
